import ContactsOutlined from '@mui/icons-material/ContactsOutlined'

import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Link from '@components/_mui/Link'
import Typography from '@components/_mui/Typography'

import Section from '@components/Details/Section'

export default function Contacts({ data, isLoading }) {
  const contacts = data?.contacts || []

  return (
    <Section title="Contacts" icon={<ContactsOutlined />}>
      <Stack sx={{ gap: 1.5 }}>
        {isLoading && [0, 1].map((i) => <Contact.Loading key={i} />)}
        {!isLoading && contacts.length === 0 && <Typography sx={{ color: 'text.secondary' }}>No contacts</Typography>}
        {!isLoading && contacts.map((contact, i) => <Contact key={i} contact={contact} />)}
      </Stack>
    </Section>
  )
}

function Contact({ contact }) {
  return (
    <Stack sx={{ minWidth: 0 }}>
      <Typography sx={{ fontWeight: 'bold', wordBreak: 'break-word' }}>{contact.name}</Typography>
      <Stack direction="row" sx={styles.meta}>
        {contact.title && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {contact.title}
          </Typography>
        )}
        {contact.email && (
          <Link variant="body2" href={`mailto:${contact.email}`} sx={{ wordBreak: 'break-all' }}>
            {contact.email}
          </Link>
        )}
      </Stack>
    </Stack>
  )
}

Contact.Loading = function () {
  return (
    <Stack>
      <Typography>
        <Skeleton width={180} />
      </Typography>
      <Typography variant="body2">
        <Skeleton width={260} />
      </Typography>
    </Stack>
  )
}

const styles = {
  meta: {
    flexWrap: 'wrap',
    columnGap: 2,
    minWidth: 0,
  },
}
